<template>
    <div class="leftInfo">
        <div class="left">
            <el-row><i :class="(show)?'el-icon-close':'el-icon-s-tools'" @click="leftInfoShow"></i></el-row>
        </div>
        <div class="right" v-if="show">
            <h4>操作指南</h4>
            <p><b>复制</b>: ctrl+c, ⌘+c</p>
            <p><b>粘贴</b>: ctrl+v, ⌘+v</p>
            <p><b>删除</b>: ctrl+x, ⌘+x, delete</p>
            <p><b>框选多个</b>: shift + 鼠标左键</p>
            <p><b>编辑文本</b>: 双击</p>
            <p><b>置于顶层、置于底层</b>:右键</p>

            <el-row style="text-align: center; margin-top: 0px">
                <img width="200px" src="@/assets/sponsor.jpg"/>
                <p>赞助开发者，提供稳定服务</p>
            </el-row>

        </div>
    </div>
</template>

<script>
export default {
    name: "LeftInfo",
    data: function () {
        return {
            show: false
        }
    },
    methods: {
        leftInfoShow() {
            this.show = !this.show
        }
    }
}
</script>

<style scoped lang="scss">
.leftInfo {
    z-index: 9999;
    position: absolute;
    right: 0px;
    top: 50%;
    bottom: 50%;
    display: flex;
    align-items: center;

    .left {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        text-align: center;
        width: 50px;
        color: #67c23a;
        font-size: 20px;
        border-radius: 10px 0 0 10px;
        background-color: #f6f6f6;
    }

    .right {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        background-color: #f6f6f6;
        padding: 10px 10px 10px 40px;
        width: 260px;
        height: 540px;
    }
}
</style>
